/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const confirmClose = () => {
		const confirmCloseBtns = document.querySelectorAll('.js-confirm-close');
		if (confirmCloseBtns.length > 0) {
			confirmCloseBtns.forEach((btn) => {
				btn.addEventListener('click', () => {
					const confirmWrap = btn.closest('.js-confirm-wrap');
					if (confirmWrap) {
						confirmWrap.style.opacity = '0';
						confirmWrap.style.transition = 'opacity .3s ease';
						confirmWrap.classList.add('is-hidden');
						confirmWrap.addEventListener('transitionend', () => {
							confirmWrap.remove();
						}, { once: true });
					}
				});
			});
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const medicineFUNCTIONS = () => {
		confirmClose();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { medicineFUNCTIONS(); }) : medicineFUNCTIONS();
})(window.FUNCTIONS);
